import { useRef, useState } from "react";
import { Database, FileUp, Upload } from "lucide-react";
import { Button } from "@/components/ui/button";

interface EmptyEvidenceStateProps {
  onBrowseCatalog: () => void;
  onFilesSelected: (files: File[]) => void;
}

const EmptyEvidenceState = ({ onBrowseCatalog, onFilesSelected }: EmptyEvidenceStateProps) => {
  const [dragActive, setDragActive] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setDragActive(false);
    if (e.dataTransfer.files.length > 0) {
      onFilesSelected(Array.from(e.dataTransfer.files));
    }
  };

  const handleFileInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.length) {
      onFilesSelected(Array.from(e.target.files));
    }
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  return (
    <div className="flex flex-col items-center max-w-xl mx-auto">
      <Button variant="brand" onClick={onBrowseCatalog} className="mb-4">
        <Database className="w-4 h-4" /> Select from Evidence Base
      </Button>

      <div className="flex items-center gap-3 w-full mb-4">
        <div className="h-px flex-1 bg-border" />
        <span className="text-xs font-medium text-muted-foreground">OR</span>
        <div className="h-px flex-1 bg-border" />
      </div>

      <input
        ref={fileInputRef}
        type="file"
        multiple
        accept=".pdf"
        onChange={handleFileInput}
        className="hidden"
      />

      <div
        className={`w-full border-2 border-dashed rounded-lg p-10 text-center transition-colors ${
          dragActive ? "border-brand-teal bg-brand-teal/5" : "border-muted-foreground/30 hover:border-brand-teal/50"
        }`}
        onDragOver={(e) => { e.preventDefault(); setDragActive(true); }}
        onDragLeave={() => setDragActive(false)}
        onDrop={handleDrop}
        onClick={() => fileInputRef.current?.click()}
      >
        <FileUp className="w-10 h-10 text-muted-foreground mx-auto mb-3" />
        <p className="text-sm font-medium text-foreground mb-1">Drop files here or click to browse</p>
        <p className="text-xs text-muted-foreground mb-3">Supports PDF</p>
        <Button variant="brand" size="sm" className="gap-1.5" onClick={(e) => { e.stopPropagation(); fileInputRef.current?.click(); }}>
          <Upload className="w-4 h-4" /> Browse Files
        </Button>
      </div>
    </div>
  );
};

export default EmptyEvidenceState;
